import _TransifexI18next from './TransifexI18next';

// eslint-disable-next-line import/prefer-default-export
export const TransifexI18next = _TransifexI18next;
